import "./IntegrationService.css";
import Button from "../../productpage/button/Button";
import { Link, useNavigate } from "react-router-dom";
const IntegrationService = () => {
  return (
    <div id="integration-service" className="outsourcemainclass">
      <div className="Container-main">
        <div className="serviceContent">
          <h2>Design, Build, and Scale—All With One Expert Team</h2>
          <p>
            Partner with a product development company delivering product
            development services and MVP consulting to design, develop, and
            launch products that delight users while supporting your business
            growth goals.
          </p>
          <div>
            <Link to="/contact_us" className="link">
              <Button
                arrowColor="#492A87"
                text="Get a Free Consultation Today"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationService;
